import { MonetizacionProvider, MonetizacionProviderProps, useMonetizacionContext } from "../contexts/monetizacion-context";

export default function Monetizacion({
    children,
    cotizacion: receivedCotizacion,
    monedas: receivedMonedas,
    transferenciaMetodos: receivedTransferenciaMetodos
}: Partial<MonetizacionProviderProps>) {
    const { cotizacion, monedas, transferenciaMetodos } = useMonetizacionContext();

    const finalCotizacion = receivedCotizacion || cotizacion;
    const finalMonedas = receivedMonedas || monedas;
    const finalTransferenciaMetodos = receivedTransferenciaMetodos || transferenciaMetodos;

    return <MonetizacionProvider
        cotizacion={finalCotizacion}
        monedas={finalMonedas}
        transferenciaMetodos={finalTransferenciaMetodos}
    >
        {children}
    </MonetizacionProvider>
}